/**
 * Puts the region in force for everything beneath it.
 *
 * The formatters read the region from a module, so it is written before the
 * children render, and the subtree is keyed on it: a changed locale or zone
 * remounts what shows an instant instead of leaving it on the old format.
 *
 * @module components/shell/RegionBoundary
 */

import React, { Fragment } from "react";

import { type Region, setRegion } from "@/utils/format-instant";

export interface RegionBoundaryProps {
  region: Region;
  children: React.ReactNode;
}

/**
 * @example
 * ```tsx
 * <RegionBoundary region={resolveRegion(tenant, user)}>{children}</RegionBoundary>
 * ```
 */
export function RegionBoundary({ region, children }: RegionBoundaryProps): React.ReactElement {
  setRegion(region);
  return <Fragment key={`${region.locale}|${region.timeZone}`}>{children}</Fragment>;
}
